import { Link } from "gatsby"
import PropTypes from "prop-types"
import React from "react"
import { Flex, Box, Heading } from "theme-ui"
import Controls from "../content/controls"

const Header = ({ siteTitle }) => (
  <header
    style={{
      background: `white`,
      marginBottom: `1.45rem`,
      flex: `0 0 auto`,
    }}
    id="site_header"
  >
    <Flex
      sx={{
        margin: `0 auto`,
        maxWidth: "40em",
        padding: `0 1.0875rem`,
        justifyContent: "space-between",
      }}
    >
      <Box sx={{ width: "100%" }}>
        <Controls />
        <Heading as="h3" sx={{ m: 0, fontSize: [3] }}>
          <Link
            to="/"
            style={{
              color: `black`,
              textDecoration: `none`,
            }}
          >
            {siteTitle}
          </Link>
        </Heading>
      </Box>
    </Flex>
  </header>
)

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
